// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__XlseN","inside":"Circle_inside__KomDd"};